import React, { useState } from "react"
import { IoIosArrowRoundBack, IoIosCheckmarkCircleOutline } from "react-icons/io"
import { EmailForm, OtpForm, PasswordForm, SuccessWrapper } from "../../components"
import { MdOutlineEmail } from "react-icons/md"
import { useHistory } from "react-router-dom"

const PasswordReset = () => {
  const router = useHistory()
  const FORM_STEPS = [
    {
      id: 0,
      title: "Forgot password?",
      description: "Don’t worry, we’ll send you reset instructions.",
      buttonText: "Send Code",
      svg: <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none"><path d="M19.79 14.93a7.575 7.575 0 0 1-7.6 1.87l-4.71 4.7c-.34.35-1.01.56-1.49.49l-2.18-.3c-.72-.1-1.39-.78-1.5-1.5l-.3-2.18c-.07-.48.16-1.15.49-1.49l4.7-4.7c-.8-2.6-.18-5.55 1.88-7.6 2.95-2.95 7.74-2.95 10.7 0 2.96 2.95 2.96 7.76.01 10.71ZM6.89 17.49l2.3 2.3" stroke="#E5B117" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" stroke="#E5B117" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
    },
    {
      id: 1,
      title: "OTP Verification",
      description: "We sent an OTP verification code to ",
      buttonText: "Verify Code",
      svg: <MdOutlineEmail className="text-yellowcolor text-3xl" />
    },
    {
      id: 2,
      title: "Reset password",
      description: "Your new password must be different to previously used passwords.",
      buttonText: "Reset Password",
      svg: <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none"><path d="M19.79 14.93a7.575 7.575 0 0 1-7.6 1.87l-4.71 4.7c-.34.35-1.01.56-1.49.49l-2.18-.3c-.72-.1-1.39-.78-1.5-1.5l-.3-2.18c-.07-.48.16-1.15.49-1.49l4.7-4.7c-.8-2.6-.18-5.55 1.88-7.6 2.95-2.95 7.74-2.95 10.7 0 2.96 2.95 2.96 7.76.01 10.71ZM6.89 17.49l2.3 2.3" stroke="#E5B117" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" stroke="#E5B117" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
    },
    {
      id: 3,
      title: "Password reset",
      description: "Your password has been successfully reset. Click below to log in effortlessly.",
      buttonText: "Log In Now",
      svg: <IoIosCheckmarkCircleOutline className="text-yellowcolor text-3xl" />
    }
  ]
  const [activeStep, setActiveStep] = useState(0)

  return (
    <div className="w-full h-screen flex items-center justify-center  background dark:bg-dark">
      <div className="p-5 rounded-md max-w-[400px] mx-auto  w-full">
        <div className="flex content-center justify-center mb-4 ">
          <div className="w-16 h-16 bg-yellowcolor/10 rounded-full flex items-center justify-center">
            <div className="w-12 h-12 bg-yellowcolor/30 dark:bg-[#FEECB8] rounded-full flex items-center justify-center">
              {FORM_STEPS[activeStep]?.svg}
            </div>
          </div>
        </div>
        <h1 className="text-center font-semibold dark:text-white text-3xl mb-3 capitalize from-neutral-900">
          {FORM_STEPS[activeStep]?.title}
        </h1>
        <div className="">
          <p className="text-center text-slate-400 font-normal text-base">
            {FORM_STEPS[activeStep]?.id === 1 ? <div>
              <span>{FORM_STEPS[activeStep]?.description}</span>
              <br />
              <span className="font-bold">{localStorage.getItem("email")}</span>
            </div> : FORM_STEPS[activeStep]?.description}
          </p>

          {{
            0: <EmailForm setActiveStep={setActiveStep} />,
            1: <OtpForm setActiveStep={setActiveStep} activeStep={activeStep} />,
            2: <PasswordForm setActiveStep={setActiveStep} activeStep={activeStep} />,
            3: <SuccessWrapper />

          }[activeStep]}

          {activeStep !== 3 && <div className="flex items-center w-full justify-center">
            <a href="/">
              <button
                className="outline-none border-none font-normal flex flex-row items-center gap-x-2 text-sm text-black dark:text-white"
              >
                <IoIosArrowRoundBack className="text-2xl" />
                <p>Back to log in</p>
              </button>
            </a>
          </div>}
        </div>
      </div>
    </div>
  )
}

export default PasswordReset
